<template>
    <div class="audio">
        <Header></Header>

        <div v-if="audio != null">

            <div class="mt-5">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-12">
                            <DivisorIcone :textSize="24" :title="'Áudio'"></DivisorIcone>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box-video mt-4">
                <div class="container">
                    <div class="row">
                        <div class="col col-lg-2"></div>
                        <div class="col-12 col-lg-8">
                            <template v-if="user || audio.flPublico == 'Sim'">
                                <div class="d-flex justify-content-center">
                                    <audio controls="controls" autoplay poster="" width="700" height="400" allowfullscreen>
                                        <source src="audio.flPublico" type="audio/mp3">
                                    </audio>
                                </div>                                
                            </template>
                            <template v-else>
                                <div class="video-thumb c-pointer" @click="abreVideo">
                                </div>
                            </template>

                        </div>
                        <div class="col col-lg-2"></div>
                    </div>
                </div>
                
            </div>

            <div class="mt-2">
                <div class="container">
                    <div class="row">
                        <div class="col col-lg-2"></div>
                        <div class="col-12 col-lg-8">
                            <p class="txt-h-2 txt-size-30 txt-blue-2 ">
                                {{audio.nmTitulo}}
                            </p>
                        </div>
                        <div class="col col-lg-2"></div>
                    </div>
                </div>
                
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 col-md-8">
                            <span class="txt-h-6 txt-size-12 txt-grey-2">{{formatDate(audio.dtAudio)}}</span>

                            <div class="mt-2 txt-p txt-grey-2 txt-size-16 recuo" v-html="audio.dsDescricao"></div>

                            <Tags class="mt-3" :titulo="'TAGS'" :lstTags="lstTags" :link="'PesquisaAudio'"></Tags>

                            <Comentarios class="mt-4" :id="audio.idAudio.toString()" :tipo="'Audio'"></Comentarios>

                            <Banner class="mt-3" :tipo="'Horizontal'" :duplo="false"></Banner>

                            <div class="mt-4">
                                <DivisorIcone :textSize="24" :title="'Mais áudios'"></DivisorIcone>

                                <div class="mais-audios mt-3">
                                    <div class="row">
                                        <div class="col-3" v-for="item in lstMaisAudios" :key="item.idAudio">
                                            <router-link :to="{name:'Audio', params:{id:item.idAudio.toString(),n:formatLink(item.nmTitulo)}}">
                                                <div class="item-mais-audios mb-3 " >
                                                        <p class="mb-0 txt-size-20 text-center">
                                                            <i class="far fa-file-audio"></i>
                                                        </p>
                                                        <span class="txt-h-6 txt-blue-2 reduz-texto-4 mb-0 text-center">{{item.nmTitulo}}</span>
                                                        <p class="txt-h-6 txt-size-12 txt-grey-2 reduz-texto-2 mb-0">{{item.dsDescricao}}</p>
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                                <div class="w-100 d-flex justify-content-center mt-4">
                                    <router-link :to="{name:'PesquisaAudio', params:{}}" class="btn btn-blue px-5 ">
                                        MAIS ÁUDIOS
                                    </router-link>
                                </div>
                            </div>

                        </div>
                        <div class="col-12 col-md-4">
                            <DivisorIcone :textSize="24" :title="'Áudios relacionados'"></DivisorIcone>
                        
                            <div class="audios-relacionados mt-3">
                                <div class="item-audios-relacionados mb-3" v-for="item in lstAudiosRelacionados" :key="item.idAudio">
                                    <router-link :to="{name:'Audio', params:{id:item.idAudio.toString(),n:formatLink(item.nmTitulo)}}">
                                        <div class="row">
                                            <div class="col-2  d-flex flex-column align-items-center justify-content-center">
                                                <p class="mb-0 txt-size-20">
                                                    <i class="far fa-file-audio"></i>
                                                </p>
                                            </div>
                                            <div class="col-6 ps-0  d-flex flex-column">
                                                <span class="txt-h-6 txt-blue-2 reduz-texto-4 mb-0">{{item.nmTitulo}}</span>
                                                <p class="txt-h-6 txt-size-12 txt-grey-2 reduz-texto-3 mb-0">{{item.dsDescricao}}</p>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>

                            <div class="banners mt-3">
                                <Banner class="mb-2" :tipo="'Lateral'"></Banner>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div v-else>
            <div class="mt-5">
                <div class="container" style="height: 44vh;">
                    <div class="row">
                        <div class="col-12 col-md-12">
                            <span class="txt-h-5 txt-blue-2">Áudio não encontrado</span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        <ModalConteudoExclusivo :showModal="showModal" :hideModal="hideModal" :logou="liberaConteudo"></ModalConteudoExclusivo>

        <Footer class="mt-5"></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import DivisorIcone from '@/components/DivisorIcone'
    import Tags from '@/components/Tags'
    import Comentarios from '@/components/Comentarios'
    import Banner from '@/components/Banner'
    import ModalConteudoExclusivo from '@/components/ModalConteudoExclusivo'


    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Audio',
        components: { Header, Footer, DivisorIcone, Tags, Comentarios, Banner,  ModalConteudoExclusivo},
        props: ['id'],
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                
                audio: null,
                lstTags: [],
                lstAudiosRelacionados: [],
                lstMaisAudios: [],

                showModal: false,
                hideModal: false,


                // ------ // 
                metaTags: {
                    title: "Sollicita",
                    meta: [
                        { itemprop: 'name', content: '' },
                        { itemprop: 'description', content: '' },
                        { itemprop: 'image', content: '' },

                        { name: 'twitter:card', content: 'summary' },
                        { name: 'twitter:site', content: '' },
                        { name: 'twitter:title', content: '' },
                        { name: 'twitter:description', content: '' },
                        { name: 'twitter:creator', content: '' },
                        { name: 'twitter:image', content: '' },

                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:title', content: '' },
                        { property: 'og:url', content: '' },
                        { property: 'og:image', content: '' },
                        { property: 'og:image:secure_url', content: '' },
                        { property: 'og:image:type', content: 'image/png' },
                        { property: 'og:description', content: '' },
                        { property: 'og:site_name', content: 'Sollicita' },
                        { property: 'og:image:width', content: '300' },
                        { property: 'og:image:height', content: '200' },
                        { property: 'fb:admins', content: 'sollicita' },
                        { property: 'og:type', content: 'website' },

                        { name: 'application-name', content: 'Sollicita' },
                        { name: 'theme-color', content: '#2d5289' },
                        { name: 'msapplication-TileColor', content: '#2d5289' },
                        { name: 'msapplication-TileImage', content: '' },
                    ]
                },

            }
        },
        metaInfo() {
            return this.metaTags
        },
        methods: {
            load() {
                this.carregaAudio();
                this.carregaAudiosRelacionados();
                this.carregaUltimosAudios();
            },

            carregaAudio() {                
                let $this = this;
                axios.get(`${urlApi}/Audio/Get/${$this.id}`)
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data) {
                                $this.audio = res.data.data;
                                $this.setMetaTags();
                                $this.montaTags($this.audio.dsTags)
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar o áudio");
                            $this.audio = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar o áudio");
                        $this.audio = null;
                    });
            },

            setMetaTags() {
                var $this = this;
                var dsDescricao = "";
                var imgDefault = window.location.origin + '114px_rounded.png';
                if ($this.audio.dsDescricao) { dsDescricao = $this.audio.dsDescricao.substring(0, ($this.audio.dsDescricao.length > 110 ? 110 : $this.audio.dsDescricao.length)); }
                $this.metaTags = {
                    title: ($this.audio.nmTitulo ? $this.audio.nmTitulo : "Sollicita"),
                    meta: [
                        { itemprop: 'name', content: ($this.audio.nmTitulo + " | Sollicita" ? $this.audio.nmTitulo : "Sollicita") },
                        { itemprop: 'description', content: (dsDescricao ? dsDescricao : "O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.") },
                        { itemprop: 'image', content: imgDefault },

                        { name: 'twitter:card', content: 'summary' },
                        { name: 'twitter:site', content: '@gruponp' },
                        { name: 'twitter:title', content: ($this.audio.nmTitulo + " | Sollicita" ? $this.audio.nmTitulo : "Sollicita") },
                        { name: 'twitter:description', content: (dsDescricao ? dsDescricao : "O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.") },
                        { name: 'twitter:creator', content: '@gruponp' },
                        { name: 'twitter:image', content: imgDefault },

                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:title', content: ($this.audio.nmTitulo + " | Sollicita" ? $this.audio.nmTitulo : "Sollicita") },
                        { property: 'og:url', content: window.location.href },
                        { property: 'og:image', content: imgDefault },
                        { property: 'og:image:secure_url', content: imgDefault },
                        { property: 'og:image:type', content: 'image/png' },
                        { property: 'og:description', content: (dsDescricao ? dsDescricao : "O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.") },
                        { property: 'og:site_name', content: 'Sollicita' },
                        { property: 'og:image:width', content: '300' },
                        { property: 'og:image:height', content: '200' },
                        { property: 'fb:admins', content: 'sollicita' },
                        { property: 'og:type', content: 'website' },

                        { name: 'application-name', content: 'Sollicita' },
                        { name: 'theme-color', content: '#2d5289' },
                        { name: 'msapplication-TileColor', content: '#2d5289' },
                        { name: 'msapplication-TileImage', content: imgDefault },
                    ]
                };
            },

            carregaAudiosRelacionados() {
                let $this = this;
                axios.get(`${urlApi}/Audio/AudiosRelacionados`, { params: { idAudio: $this.id, take: 6, index: 0 } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstAudiosRelacionados = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let audio = res.data.data.rows[i];

                                    $this.lstAudiosRelacionados.push(audio);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os áudios");
                            $this.lstAudiosRelacionados = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os áudios");
                        $this.lstAudiosRelacionados = null;
                    });
            },

            carregaUltimosAudios() {
                let $this = this;
                axios.get(`${urlApi}/Audio/UltimosAudios`, { params: { n_idAudio: $this.id, take: 3, index: 0 } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstMaisAudios = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {

                                    let item = res.data.data.rows[i];

                                    $this.lstMaisAudios.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os áudios");
                            $this.lstMaisAudios = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os áudios");
                        $this.lstMaisAudios = null;
                    });
            },

            montaTags(tags) {
                let $this = this;
                if (tags != null && tags != undefined) {
                    tags = tags.split(';');
                    if (tags != undefined && tags != null && tags != '') {
                        for (let i = 0; i < tags.length; i++) {
                            let tag = tags[i].trim();
                            $this.lstTags.push(tag);
                        }
                    }
                }
            },

            formatDate(date) {
                return moment(date).format('DD/MM/YYYY [às] HH:mm');
            },
                        
            formatLink(titulo) {
                if (titulo) {
                    return titulo.toLowerCase().replace(/\s/g, '-');
                } else {
                    return "";
                }
            },


            abreVideo() {
                this.showModal = !this.showModal;
            },


            liberaConteudo() {
                this.hideModal = !this.hideModal;
            }

        },
        created: function () {
            this.load();
        },
        watch: {
            id() {
                this.load();
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .audio-thumb {
        position: relative;
        background-color: gray;

        img {
            width: 500px;
            height: 500px;
        }
    }

    .mais-audios {
        .item-mais-audios {
            display: flex;
            flex-direction: column;
            justify-content: center;
            border: 1px solid #dedede;
            background-color: #EBEBEB;
            border-radius: 10px;
            padding: 10px;

            height: 100px;
            max-height: 100px;
        }
    }


    .box-video {
        background: color('grey','4');


        .video-player {
            width: 100%;
            height: 100%;
            max-width: 100%;
        }
    }

    .banner-lateral {
        width: 100%;
        height: auto;
        max-height: 430px;
    }

    .video-thumb {
        position: relative;
        min-height: 300px;
        background-color: gray;
        
        img {
            width: 500px;
            height: 500px;
        }
    }

    .box-imagem {
        position: relative;
    }

    .video-thumb:hover:after, .box-imagem:hover:after, .audio-thumb:hover:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,0.3);
    }

    .video-thumb:before, .audio-thumb:before {
        position: absolute;
        content: "";
        display: block;
        transition: opacity .3s;
        width: 100%;
        height: 100%;
        background: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyNDAiPjxkZWZzPjxmaWx0ZXIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iYSI+PGZlT2Zmc2V0IGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyLjUiIGluPSJzaGFkb3dPZmZzZXRPdXRlcjEiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSIvPjxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC41MjUgMCIgaW49InNoYWRvd0JsdXJPdXRlcjEiIHJlc3VsdD0ic2hhZG93TWF0cml4T3V0ZXIxIi8+PGZlTWVyZ2U+PGZlTWVyZ2VOb2RlIGluPSJzaGFkb3dNYXRyaXhPdXRlcjEiLz48ZmVNZXJnZU5vZGUgaW49IlNvdXJjZUdyYXBoaWMiLz48L2ZlTWVyZ2U+PC9maWx0ZXI+PC9kZWZzPjxwYXRoIGQ9Ik0yNC4zNSAxNy4wNDVMNi41OCA1LjE2N0M2LjQyMyA1LjA2MiA2LjI0IDUgNi4wNCA1IDUuNDY4IDUgNSA1LjUyIDUgNi4xNmwuMDAyLjA0OEg1VjI5LjljMCAuNjQuNDY3IDEuMTYgMS4wNCAxLjE2LjE5NyAwIC4zOC0uMDYyLjUzNS0uMTY2TDI0LjM1IDE5LjAxNmMuMjk1LS4yMDYuNDkzLS41Ny40OTMtLjk4NyAwLS40MTctLjE5Ny0uNzgtLjQ5My0uOTg1IiBvcGFjaXR5PSIuODUiIGZpbGw9IiNGRkYiIGZpbHRlcj0idXJsKCNhKSIvPjwvc3ZnPg==) no-repeat 50%;
        opacity: 1;
        z-index: 1;
        top: -5px;
        left: 0;
        background-size: 65px 79px;
    }

    .box-imagem:before {
        position: absolute;
        content: "";
        display: block;
        transition: opacity .3s;
        width: 100%;
        height: 100%;
        background: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyNDAiPjxkZWZzPjxmaWx0ZXIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iYSI+PGZlT2Zmc2V0IGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyLjUiIGluPSJzaGFkb3dPZmZzZXRPdXRlcjEiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSIvPjxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC41MjUgMCIgaW49InNoYWRvd0JsdXJPdXRlcjEiIHJlc3VsdD0ic2hhZG93TWF0cml4T3V0ZXIxIi8+PGZlTWVyZ2U+PGZlTWVyZ2VOb2RlIGluPSJzaGFkb3dNYXRyaXhPdXRlcjEiLz48ZmVNZXJnZU5vZGUgaW49IlNvdXJjZUdyYXBoaWMiLz48L2ZlTWVyZ2U+PC9maWx0ZXI+PC9kZWZzPjxwYXRoIGQ9Ik0yNC4zNSAxNy4wNDVMNi41OCA1LjE2N0M2LjQyMyA1LjA2MiA2LjI0IDUgNi4wNCA1IDUuNDY4IDUgNSA1LjUyIDUgNi4xNmwuMDAyLjA0OEg1VjI5LjljMCAuNjQuNDY3IDEuMTYgMS4wNCAxLjE2LjE5NyAwIC4zOC0uMDYyLjUzNS0uMTY2TDI0LjM1IDE5LjAxNmMuMjk1LS4yMDYuNDkzLS41Ny40OTMtLjk4NyAwLS40MTctLjE5Ny0uNzgtLjQ5My0uOTg1IiBvcGFjaXR5PSIuODUiIGZpbGw9IiNGRkYiIGZpbHRlcj0idXJsKCNhKSIvPjwvc3ZnPg==) no-repeat 50%;
        opacity: 1;
        z-index: 1;
        top: -5px;
        left: 0;
        background-size: 35px 43px;
    }

    @media (max-width: 575.98px) {
        .video-thumb:before, .audio-thumb:before {
            background-size: 65px 79px !important;
        }
    }
    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) and (max-width: 999px) {
        .video-thumb:before, .audio-thumb:before {
            background-size: 30px 43px !important;
        }
    }
</style>

